import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './Seguridad.css';

const securityProducts = [
  {
    name: 'Microsoft Intune',
    description:
      'Administre dispositivos Windows, macOS, iOS y Android con políticas centralizadas, cumplimiento automatizado y protección de datos.'
  },
  {
    name: 'Kerio Control',
    description:
      'Firewall de próxima generación con filtrado web, IDS/IPS, VPN y balanceo de carga para asegurar redes híbridas y sucursales.'
  },
  {
    name: 'GFI LanGuard',
    description:
      'Escanea vulnerabilidades, gestiona parches y audita activos en tiempo real para mantener su infraestructura confiable.'
  }
];

const useCases = [
  {
    title: 'Gobierno de endpoints',
    description:
      'Integre Intune con Azure AD para aplicar políticas de refuerzo, cifrado y acceso condicional al ecosistema de factoring.'
  },
  {
    title: 'Perímetro seguro',
    description:
      'Utilice Kerio Control para segmentar redes, aislar oficinas de agentes y ofrecer VPN segura a sus ejecutivos.'
  },
  {
    title: 'Auditoría continua',
    description:
      'Automatice con LanGuard la detección de vulnerabilidades, control de parches y reportes de cumplimiento para la DGI y auditores.'
  }
];

function Seguridad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='seguridad-page'>
      <Helmet>
        <title>Seguridad Gestionada | TEKINS</title>
        <meta
          name='description'
          content='Proteja su operación de factoring con soluciones Microsoft Intune, Kerio Control y GFI LanGuard implementadas por TEKINS.'
        />
      </Helmet>

      <section className='seguridad-hero'>
        <div className='seguridad-hero__content'>
          <div>
            <h1>Seguridad administrada para factoring y confirming</h1>
            <p>
              Construimos arquitecturas seguras que combinan políticas de endpoint, firewalls de próxima generación y gestión de
              vulnerabilidades. Nuestros especialistas alinean cada despliegue con las exigencias regulatorias panameñas.
            </p>
          </div>
        </div>
      </section>

      <section className='seguridad-grid'>
        <div className='seguridad-grid__intro'>
          <h2>Suite recomendada</h2>
          <p>
            Estos tres componentes forman el núcleo de seguridad que desplegamos en instituciones financieras, fintech y empresas que
            operan factoring y confirming con TEKINS.
          </p>
        </div>

        <div className='product-grid'>
          {securityProducts.map((product) => (
            <article className='product-card' key={product.name}>
              <h3>{product.name}</h3>
              <p>{product.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className='use-case-section'>
        <div className='use-case-inner'>
          <h2>Casos de uso frecuentes</h2>
          <div className='use-case-cards'>
            {useCases.map((item) => (
              <article className='use-case-card' key={item.title}>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className='seguridad-cta'>
        <div className='seguridad-cta-inner'>
          <h2>Diseñemos su roadmap de seguridad</h2>
          <p>
            Podemos auditar su ecosistema actual y proponer un plan por fases que incluya Intune, Kerio Control y LanGuard alineado a su
            operación de factoring.
          </p>
          <div className='action-row'>
            <a className='seguridad-button primary' href='mailto:info@tekins.com?subject=Seguridad%20TEKINS'>Agenda una consulta</a>
            <a
              className='seguridad-button secondary'
              href='https://api.whatsapp.com/send?phone=50766435949&text=Quiero%20informaci%C3%B3n%20sobre%20seguridad%20TEKINS'
            >
              Hablar con un especialista
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Seguridad;
